export function retryImport(factory, retries = 3, interval = 1000) {
    return new Promise((resolve, reject) => {
        factory()
            .then(resolve)
            .catch((error) => {
                if (retries <= 0) return reject(error)
                setTimeout(() => {
                    retryImport(factory, retries - 1, interval).then(resolve, reject)
                }, interval)
            })
    })
}
